var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircularDeterminate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0781 29.7799L47.4225 24.9117L54.167 20.6149L61.2603 16.9224L68.6485 13.8621L76.2752 11.4574L84.0826 9.72656",
    stroke: "#171717",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.917 9.72656L123.725 11.4574L131.352 13.8621L138.74 16.9224L145.833 20.6149L152.578 24.9117L158.922 29.7799L164.818 35.1825L170.22 41.0784L175.089 47.4228L179.385 54.1673L183.078 61.2606L186.138 68.6488L188.543 76.2755L190.274 84.0829L191.318 92.0113L191.666 100.001L191.318 107.99L190.274 115.918L188.543 123.726L186.138 131.352L183.078 138.741L179.385 145.834L175.089 152.578L170.22 158.923L164.818 164.819L158.922 170.221L152.578 175.09L145.833 179.386L138.74 183.079L131.352 186.139L123.725 188.544L115.917 190.275L107.989 191.318L99.9997 191.667L92.0104 191.318L84.0819 190.275L76.2746 188.544L68.6478 186.139L61.2597 183.079L54.1663 179.386L47.4218 175.09L41.0775 170.221L35.1816 164.819L29.7789 158.923L24.9107 152.578L20.614 145.834L16.9215 138.741L13.8612 131.352L11.4565 123.726L9.72563 115.918L8.68183 107.99L8.33301 100.001L8.68183 92.0113L9.72563 84.0829L11.4565 76.2755L13.8612 68.6488L16.9215 61.2606L20.614 54.1673",
    stroke: "#FB4764",
    strokeWidth: 15,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularDeterminate);
export default __webpack_public_path__ + "static/media/circular-determinate.7ede8d1a6e8926e1af9b6f2fbc01eb16.svg";
export { ForwardRef as ReactComponent };